export default "__VITE_ASSET__BF0XGm7I__"